import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
export function DefaultButton() {
  const {
    appContext,
    published
  } = useDetailsPageContext();
  const isPreview = !published;
  const buttonText = appContext === 'public' ? 'detailsPage.productDetailsCard.cta.signIn' : 'detailsPage.productDetailsCard.cta.install';
  return /*#__PURE__*/_jsx(Button, {
    use: "primary",
    disabled: isPreview,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: buttonText
    })
  });
}